import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

// Free text, suggesting projects already in use so one project is not typed
// three different ways.
export function ProjectInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const docsQuery = useQuery({ queryKey: ["documents"], queryFn: api.listDocuments });
  const projects = [
    ...new Set((docsQuery.data ?? []).flatMap((d) => (d.project_name ? [d.project_name] : []))),
  ].sort((a, b) => a.localeCompare(b, "pl"));
  return (
    <label className="project-input">
      <span className="field-label">Project</span>
      <input
        className="field"
        type="text"
        maxLength={200}
        list="known-projects"
        placeholder="e.g. PV Dąbie"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <datalist id="known-projects">
        {projects.map((project) => (
          <option key={project} value={project} />
        ))}
      </datalist>
    </label>
  );
}
